import type { ComponentType } from "react";
import Loader from "ui/molecules/Loader";
import { useApplicationDetailContext } from "../ApplicationDetailProvider";

export const withStepData = (Component: ComponentType) => <TProps extends object>(props: TProps) => {
    const { isLoading } = useApplicationDetailContext();

    return (
        <Loader
            isLoading={isLoading}
        >
            <Component
                {...props}
            />
        </Loader>
    );
};

export default withStepData;
